import React from 'react';

// Cycled so a loading list never reads as a mechanical grid of identical bars.
const TITLE_WIDTHS = [86, 62, 94, 71, 52, 88, 67, 79];

export default function StoriesSkeleton({ rows = 8, fadeLast = true }) {
    return (
        <div role="status" aria-busy="true" aria-label="Loading stories">
            {Array.from({ length: rows }, (_, i) => (
                <div
                    key={i}
                    className={`sf-story-row sf-skel-row${fadeLast && i === rows - 1 ? ' sf-skel-row-faint' : ''}`}
                    aria-hidden="true"
                    style={{ animationDelay: `${i * 0.08}s` }}
                >
                    <span className="sf-row-chevron"><span className="sf-skel-chev" /></span>
                    <div className="sf-row-content">
                        <div className="sf-skel-titlebox">
                            <div className="sf-skel-line" style={{ width: `${TITLE_WIDTHS[i % TITLE_WIDTHS.length]}%` }} />
                        </div>
                    </div>
                    <span className="sf-skel-count" />
                    <span className="sf-skel-share" />
                    <span className="sf-skel-next" />
                </div>
            ))}
        </div>
    );
}
